
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/public-certificates/[uuid]/[slug]",
      function () {
        return require("private-next-pages/public-certificates/[uuid]/[slug].jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/public-certificates/[uuid]/[slug]"])
      });
    }
  